import React from 'react';
import { Button } from 'reactstrap';
import './editButtons.scss';

// The buttons at the foot of every add / edit form. Until the admin changes a field the only way out is "Exit edit
// page" (leaves: nothing to save); once they have, "Save and exit" (the form's submit) and "Discard changes" (leaves
// without saving). onExit is used for both ways out without saving.
// A form counts as changed from the admin's first edit: typing in it (markChanged as the form's onChangeCapture
// catches every text field, list and tick box) or a pick in a list, date or map whose handler calls markChanged.
// Loading the record into the form is not a change.
export default function EditButtons({ changed, onExit, saving }) {
	if (!changed) {
		return (
			<div className="edit-buttons">
				<Button type="button" color="primary" className="edit-button" onClick={onExit}>Exit edit page</Button>
			</div>
		);
	}
	return (
		<div className="edit-buttons">
			<Button type="submit" color="primary" className="edit-button" disabled={!!saving}>Save and exit</Button>
			<Button type="button" color="secondary" outline className="edit-button" onClick={onExit}>Discard changes</Button>
		</div>
	);
}

// For a class form: <form onChangeCapture={markChanged(this)}> and markChanged(this)() in other handlers
export function markChanged(component) {
	return () => {
		if (!component.state || !component.state.formChanged) {
			component.setState({ formChanged: true });
		}
	};
}

// A handler of a pick (list, date, switch, photo) that also counts as a change: onChange={withChange(this, this.pick)}
export function withChange(component, handler) {
	return (...args) => {
		markChanged(component)();
		return handler(...args);
	};
}
